import { Link } from 'react-router-dom';
import CapeTownVideo from './assets/Cape_Town_Drone_Video_Reversed.mp4';
import TownShip from './assets/township tours.jpg';
import SafariDayTour from './assets/SafariTours.jpg';
import CapePeninsulaImage from './assets/cape-peninsula.jpg'; 
import CitytourImage from './assets/CityTour.jpg';
import Winelands from './assets/Winelands.jpg';
import SafariMultiDay from './assets/SafariMult.jpg';
import SafariNight from './assets/SafariNight.jpg';
import Paragliding from './assets/Paragliding.jpg'; 
import Ziplining from './assets/ziplining.jpg';
import SharkDiving from './assets/Shark Diving.jpg';


function HomePage() {
  const featuredDayTours = [
    {
      id: 1,
      title: 'Cape Town City Tour',
      description: 'Explore the great food, art, history, and nightlife of Africa’s oldest and most exciting city with Ebamba.',
      image: CitytourImage
    },
    {
      id: 2,
      title: 'Cape Point & Peninsula Tour',
      description: 'Our signature tour covers the dramatic cliffs of the Atlantic Seaboard, penguins at Boulders Beach, and culminates at the iconic Cape Point.',
      image: CapePeninsulaImage
    },
    {
      id: 3,
      title: 'Cape Winelands Tour',
      description: 'Enjoy some of the world’s most beautiful scenery – and taste some of the world’s great wines – on our Ebamba Cape Winelands Tours.',
      image: Winelands
    },
    {
      id: 4,
      title: 'Township Tour Cape Town',
      description: 'The Cape Town Township tour offers visitors insight into South African culture like no other. Walk in the shoes of most South Africans and see what life is like for them.',
      image: TownShip
    }
  ];

  const featuredSafaris = [
    {
        id: 1,
        title: 'Full Day Safari Cape Town',
        description: "Sometimes you spot the lion and sometimes a gazelle, keep wandering and you'll come across something worth chasing after with Ebamba.",
        image: SafariDayTour
    },
    {
        id: 2,
        title: 'Overnight Safari Cape Town',
        description: "Embrace the unknown, take the bumpy ride and let the beauty of the wilderness awaken your soul with one of our overnight Safaris.",
        image: SafariNight
    },
    {
        id: 3,
        title: 'Multi-Day Safari Cape Town',
        description: "Let the adventure of a multi-day Safari guide you to memories that will stay with you forever!",
        image: SafariMultiDay
    }
  ];

  const featuredActivities = [
    {
        id: 1,
        title: 'Paragliding Cape Town',
        description: 'Experience the most popular adrenaline activity in the city, available all year round.',
        image: Paragliding
    },
    {
        id: 2,
        title: 'Shark Cage Diving',
        description: 'A thrilling full-day experience just two hours from Cape Town in Gansbaai, the shark capital.',
        image: SharkDiving
    },
    {
        id: 3,
        title: 'Ziplining Cape Town',
        description: 'Exhilarating ziplining experiences offering stunning panoramic vistas of the city\'s natural beauty.',
        image: Ziplining
    }
  ];


  return (
    <>
      <section id="home" className="hero video-background">
        <video autoPlay loop muted playsInline className="hero-video">
          <source src={CapeTownVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Ebamba Travel & Tours: Your Premier Cape Town Experience</h1>
          <p>We Specialize in Private, Guided Cape Town Tours. The best way to experience Cape Town is to have your itinerary focused on your interests, and our job is to assist you in making this happen.</p>
          <Link to="/contact" className="btn btn-primary large-btn">Contact Us Today</Link>
        </div>
      </section>

      {/* --- Why Choose Ebamba Section --- */}
      <section className="about-us-intro section-spacing">
        <div className="container">
          <h2>Why Choose Ebamba for Your Cape Town Tours?</h2>
          <p>Ebamba Travel & Tours is your dedicated Cape Town Tours Operator, specializing in private, personalized journeys. We work with you to curate luxurious, bespoke experiences of South Africa’s ‘Mother City’ and the surrounding regions.</p>
          <p>Our Cape Town Tours combine intimate local knowledge and world-class refinement. From iconic landmarks to the best-kept secrets, we showcase Cape Town in all its splendor and variety. At Ebamba, we put people first. We are committed to offering exceptional service and creating experiences that cater to each client’s individual needs, ensuring your visit to Cape Town is unique and unforgettable. Explore the world’s most beautiful city with Ebamba Travel & Tours!</p>
          <div className="contact-links" style={{marginTop: '2rem'}}>
            <a href="https://wa.me/27736730809" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i> Chat with Us on WhatsApp
            </a>
            <a href="tel:+27736730809" className="btn btn-call">
                <i className="fas fa-phone"></i> Call Ebamba Now
            </a>
          </div>
        </div>
      </section>

      {/* --- Featured Day Tours Section --- */}
      <section className="featured-tours-section section-spacing light-bg">
          <div className="container">
              <h2>Ebamba's Featured Day Tours</h2>
              <div className="tour-grid">
                {featuredDayTours.map(tour => (
                    <div className="tour-card" key={tour.id}>
                        <img src={tour.image} alt={tour.title} /> {/* Using tour.image directly here */}
                        <h3>{tour.title}</h3>
                        <p>{tour.description}</p>
                        <Link to={`/tours#${tour.id}`} className="btn btn-primary" style={{margin: '1rem', display: 'block'}}>More Info</Link>
                    </div>
                ))}
              </div>
              <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                  <Link to="/tours" className="btn btn-primary large-btn">View All Cape Town Tours</Link>
              </div>
          </div>
      </section>

      {/* --- Safari Cape Town Section --- */}
      <section className="safari-section section-spacing">
          <div className="container">
              <h2>Safari Cape Town with Ebamba</h2>
              <p>When it comes to adding a Safari to your Cape Town tour, Ebamba offers a variety of Game Reserve and experience options. Whether it's a full day or overnight Safari, part of a romantic getaway or family holiday, we have something to suit you.</p>
              <div className="tour-grid">
                {featuredSafaris.map(safari => (
                    <div className="tour-card" key={safari.id}>
                        <img src={safari.image} alt={safari.title} />
                        <h3>{safari.title}</h3>
                        <p>{safari.description}</p>
                        <Link to="/contact" className="btn btn-primary" style={{margin: '1rem', display: 'block'}}>Contact Us</Link>
                    </div>
                ))}
              </div>
              <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                  <Link to="/tours" className="btn btn-primary large-btn">Explore All Safari Options</Link>
              </div>
          </div>
      </section>

      {/* --- Cape Town Activities Section --- */}
      <section className="activities-section section-spacing light-bg">
          <div className="container">
              <h2>Thrilling Cape Town Activities</h2>
              <p>Dive into adventure with Ebamba Travel & Tours. Cape Town offers a myriad of exciting activities for every thrill-seeker and explorer.</p>
              <div className="tour-grid">
                {featuredActivities.map(activity => (
                    <div className="tour-card" key={activity.id}>
                        <img src={activity.image} alt={activity.title} />
                        <h3>{activity.title}</h3>
                        <p>{activity.description}</p>
                        <Link to="/contact" className="btn btn-primary" style={{margin: '1rem', display: 'block'}}>More Info</Link>
                    </div>
                ))}
              </div>
              <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                  <Link to="/tours" className="btn btn-primary large-btn">Discover More Activities</Link>
              </div>
          </div>
      </section>

      {/* --- Chauffeur Service Callout --- */}
      <section className="chauffeur-section section-spacing primary-bg-dark">
        <div className="container text-center text-white">
          <h2>Ebamba Chauffeur Service</h2>
          <p>Add a touch of elegance to your Cape Town experience. Our fleet, ranging from Mercedes C Class to V Class, offers a luxurious chauffeur solution for both corporate and leisure groups, small or large.</p>
          <Link to="/contact" className="btn btn-secondary large-btn">Enquire About Chauffeur Service</Link>
        </div>
      </section>
    </>
  );
}

export default HomePage;
